import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap"
import {Switch} from "antd";

class ModalChangeStatus extends Component {
    _handleChangeStatus = (checked) => {
        const {onChangeStatus} = this.props

        if (typeof onChangeStatus === 'function') {
            onChangeStatus(checked)
        }
    }

    render() {
        const {isOpen, toggle, loading, error, status, onChange} = this.props

        return (
            <div className='ModalConfirm'>
                <Modal isOpen={isOpen} toggle={this._toggle}>
                    <ModalHeader toggle={toggle}>Thay đổi trạng thái</ModalHeader>
                    <ModalBody>
                        <div className="Status row">
                            <label className="col-sm-3 col-form-label">Trạng thái </label>
                            <div className="col-sm-9">
                                <Switch onChange={this._handleChangeStatus} checked={status}
                                        checkedChildren="Bật" unCheckedChildren="Tắt"/>
                            </div>
                        </div>
                        {error && <span className='text-danger mt-3'>{error}</span>}
                    </ModalBody>
                    <ModalFooter className='d-flex justify-content-between align-items-center'>
                        <Button disabled={loading} color="secondary" onClick={toggle}>Hủy</Button>
                        <Button disabled={loading} color="primary" onClick={onChange}>
                            {loading && <i className='fa fa-spin fa-spinner mr-2'/>} Cập nhật
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

ModalChangeStatus.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    arrSelected: PropTypes.array,
    loading: PropTypes.bool,
    error: PropTypes.string
}

export default ModalChangeStatus